module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "leftbar-view elffy-dashboard",
    class: {
      'left-aside-toggle': _vm.toggle_aside
    }
  }, [_c('section', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "material-table-widget dashboard_top_bar"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-md-offset-3"
  }, [_c('h3', {
    staticClass: "text-center",
    staticStyle: {
      "margin": "6px 0px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.filter_year) + "年度業務分析 - " + _vm._s(_vm.current_user_name))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 form-inline text-right display-block"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter_year),
      expression: "filter_year"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filter_year = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.queryData]
    }
  }, _vm._l((_vm.year_range), function(year) {
    return _c('option', {
      domProps: {
        "value": year
      }
    }, [_vm._v(_vm._s(year))])
  })), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter_sales),
      expression: "filter_sales"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filter_sales = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.queryData]
    }
  }, [_c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("所有人")]), _vm._v(" "), _vm._l((_vm.company_users), function(user) {
    return _c('option', {
      domProps: {
        "value": user.user_tag
      }
    }, [_vm._v(_vm._s(user.user_name))])
  })], 2)])])]), _vm._v(" "), (_vm.filter_sales == 'all') ? _c('div', {
    staticClass: "widget-wrap padding-0"
  }, [_c('h3', [_vm._v("團隊績效：達成率 " + _vm._s(_vm.floatRound(_vm.allValue / _vm.allTarget)) + " "), _c('br'), _c('small', [_vm._v("總達成金額：$ " + _vm._s(_vm.allValue.toLocaleString()) + " , 總業績目標：$ " + _vm._s(_vm.allTarget.toLocaleString()))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_c('div', {
    ref: "chart_team_revenue",
    staticStyle: {
      "width": "100%",
      "height": "400px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-4 text-left"
  }, _vm._l((_vm.orderedUserByValue), function(user) {
    return _c('div', {
      staticStyle: {
        "position": "relative",
        "height": "100px"
      }
    }, [_c('img', {
      staticClass: "avatar-size",
      staticStyle: {
        "margin-top": "20px"
      },
      attrs: {
        "src": user.avatar
      }
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "position": "absolute",
        "left": "45px",
        "top": "0px"
      }
    }, [_c('span', [_vm._v(_vm._s(user.user_name))]), _vm._v(" ("), _c('span', [_vm._v(_vm._s(_vm.floatRound(user.total_target / user.expect_target)))]), _vm._v(")\n                    "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "text-gray"
    }, [_vm._v("完成金額：$ " + _vm._s(user.total_target.toLocaleString()))]), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "text-gray"
    }, [_vm._v("目標金額：$ " + _vm._s(user.expect_target.toLocaleString()))])])])
  }))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "widget-wrap padding-0"
  }, [_c('div', {}), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.deals_title), function(title) {
    return _c('div', {
      staticClass: "col"
    }, [(title == 'won') ? _c('h3', {
      staticClass: "text-success"
    }, [_vm._v("已成交訂單：" + _vm._s(_vm.dealTotal(title)))]) : (title == 'lost') ? _c('h3', {
      staticClass: "text-danger"
    }, [_vm._v("已丟失訂單：" + _vm._s(_vm.dealTotal(title)))]) : (title == 'all') ? _c('h3', {
      staticClass: "text-info"
    }, [_vm._v("總訂單：" + _vm._s(_vm.dealTotal(title)))]) : _vm._e(), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.dealCount(title)) + "筆 / " + _vm._s(_vm.dealRate(title)))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "widget-wrap padding-0"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "widget-container"
  }, [_c('div', {
    ref: "chartdiv",
    staticStyle: {
      "width": "100%",
      "height": "400px"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "widget-wrap padding-0"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "widget-container"
  }, [_c('div', {
    staticClass: "widget-content"
  }, [_c('div', {
    ref: "chart_funnel",
    staticStyle: {
      "width": "100%",
      "height": "400px"
    }
  })])])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "deal_sidebar block-header clearfix"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_c('p', [_vm._v("每月成交金額")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "deal_sidebar block-header clearfix"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_c('p', [_vm._v("各階段轉換率")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53dd8407","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Analytics/Sales.vue
// module id = 689
// module chunks = 4